<div class="container fadeIn animated">
    <div class="row">
        <div class="col-12">
            <div class="fadeTitle space-xl">
                <h3 class="fw-sbold fs-30">¡Ya casi terminamos!</h3>
                <p class="fs-14">Ahora que sabemos que <strong class="cl-secundary">{{company}}</strong> esta bajo tu propiedad.<br>En esta última sección te solicitaremos que adjuntes algunos documentos</p>
            </div>

            <form [formGroup]="thirdFormDev" (ngSubmit)="finishRegister()" class="fadeForm">

                <div class="d-block space-xl">
                    <div class="mb-3 mt-4 col-11 col-md-9">
                      <div class="d-flex justify-content-between w-100" *ngIf="INEFile">
                        <div class="cl-primary">
                          <p class="me-3 mb-1 cl-primary">Credencial de elector ambos lados (INE/IFE) del representante legal subida: </p>
                          <p class=""><strong>{{ INEFile }}</strong></p>
                        </div>
                        <fa-icon [icon]="iconReUpload" title="Subir otro archivo" class="cr-pointer cl-primary my-auto"
                            (click)="INEDefined = INEFile; INEFile = undefined">
                        </fa-icon>
                      </div>
                      <file-pond #pondine [options]="ineOptions" [files]="ineFiles" (onaddfile)="pondHandleAddFile($event, 'ine')"
                        (onremovefile)="deleteFile('ine')" *ngIf="!INEFile" [ngStyle]="{'width': INEDefined ? '90%' : '100%' }">
                      </file-pond>
                      <fa-icon [icon]="iconX" *ngIf="INEDefined" class="cr-pointer cl-primary my-auto"
                      (click)="INEFile = INEDefined; INEDefined = undefined"></fa-icon>
                    </div>
                </div>

                <div class="d-block space-xl">
                <div class="mb-3 mt-4 col-11 col-md-9">
                  <div class="d-flex justify-content-between w-100" *ngIf="certFile">
                    <div class="cl-primary">
                      <p class="me-3 mb-1 cl-primary">Cédula de identificación fiscal de la empresa subida: </p>
                      <p class=""><strong>{{ certFile }}</strong></p>
                    </div>
                    <fa-icon [icon]="iconReUpload" title="Subir otro archivo" class="cr-pointer cl-primary my-auto"
                        (click)="certFileDefined = certFileFile; certFileFile = undefined">
                    </fa-icon>
                  </div>
                  <file-pond #pondCert [options]="certOptions" [files]="certFiles" (onaddfile)="pondHandleAddFile($event, 'cert')"
                    (onremovefile)="deleteFile('cert')" *ngIf="!certFile" [ngStyle]="{'width': certDefined ? '90%' : '100%' }">
                  </file-pond>
                  <fa-icon [icon]="iconX" *ngIf="certDefined" class="cr-pointer cl-primary my-auto"
                  (click)="certFile = certDefined; certDefined = undefined"></fa-icon>
                </div>
                </div>

                <div class="d-block space-xl">
                <div class="mb-3 mt-3 col-11 col-md-9">
                  <div class="d-flex justify-content-between w-100" *ngIf="actFile">
                    <div class="cl-primary">
                      <p class="me-3 mb-1 cl-primary">Acta Constitutiva subida: </p>
                      <p class=""><strong>{{ actFile }}</strong></p>
                    </div>
                    <fa-icon [icon]="iconReUpload" title="Subir otro archivo" class="cr-pointer cl-primary my-auto"
                        (click)="actDefined = actFile; actFile = undefined">
                    </fa-icon>
                  </div>
                  <file-pond #pondAct [options]="actOptions" [files]="certFiles" (onaddfile)="pondHandleAddFile($event, 'act')"
                    (onremovefile)="deleteFile('act')" *ngIf="!actFile" [ngStyle]="{'width': actDefined ? '90%' : '100%' }">
                  </file-pond>
                  <fa-icon [icon]="iconX" *ngIf="actDefined" class="cr-pointer cl-primary my-auto"
                  (click)="actFile = actDefined; actDefined = undefined"></fa-icon>
                </div>
                </div>

                <div class="my-3">
                <label class="mnf-control-label">¿El Poder individual se encuentra dentro de la acta constitutiva?</label>
                <mat-radio-group formControlName="powerInConstitutiveAct">
                   <mat-radio-button [value]="defaultOptions[0]" defaultOptions>Sí</mat-radio-button>
                   <mat-radio-button [value]="defaultOptions[1]" class="ms-4">No</mat-radio-button>
                </mat-radio-group>
                </div>

                <div class="fadeShow col-5 my-4" *ngIf="forms.powerInConstitutiveAct.value === 'Si'">
                    <mnf-input-form formControlName="pageToFoundPowerInAct" label="¿Entre que páginas se encuentra?" placeholder="Ej: DE LA 23 A LA 45"  errMsg="Debe estar lleno éste campo" *ngIf="forms.powerInConstitutiveAct.value === 'Si'"></mnf-input-form>
                </div>

                <div class="fadeShow d-block my-4" *ngIf="forms.powerInConstitutiveAct.value === 'No'">
                <div class="mb-3 mt-4 col-11 col-md-9">
                  <div class="d-flex justify-content-between w-100" *ngIf="powerIndividualFile">
                    <div class="cl-primary">
                      <p class="me-3 mb-1 cl-primary">Poder individual subida: </p>
                      <p class=""><strong>{{ powerIndividualFile }}</strong></p>
                    </div>
                    <fa-icon [icon]="iconReUpload" title="Subir otro archivo" class="cr-pointer cl-primary my-auto"
                        (click)="powerIndividualDefined = powerIndividualFile; powerIndividualFile = undefined">
                    </fa-icon>
                  </div>
                  <file-pond #pondpowerIndividual [options]="powerIndividualOptions" [files]="powerIndividualFiles" (onaddfile)="pondHandleAddFile($event, 'powerIndividual')"
                    (onremovefile)="deleteFile('powerIndividual')" *ngIf="!powerIndividualFile" [ngStyle]="{'width': powerIndividualDefined ? '90%' : '100%' }">
                  </file-pond>
                  <fa-icon [icon]="iconX" *ngIf="powerIndividualDefined" class="cr-pointer cl-primary my-auto"
                  (click)="powerIndividualFile = powerIndividualDefined; powerIndividualDefined = undefined"></fa-icon>
                </div>
                </div>

                <div class="my-5">
                  <button mat-button (click)="returnToStep()"> ❮ </button>
                  <button mat-button type="submit" [disabled]="validForm()" class="ms-3"> ❯ </button>
              </div>
            </form>

        </div>
    </div>
</div>